export class SparkJobRequestedSource {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "type",
            "baseName": "type",
            "type": "SparkJobSourceType",
            "format": ""
        },
        {
            "name": "uri",
            "baseName": "uri",
            "type": "string",
            "format": ""
        },
        {
            "name": "repositoryId",
            "baseName": "repositoryId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "ref",
            "baseName": "ref",
            "type": "RepositoryRef",
            "format": ""
        },
        {
            "name": "commitSha",
            "baseName": "commitSha",
            "type": "string",
            "format": ""
        },
        {
            "name": "rootPath",
            "baseName": "rootPath",
            "type": "string",
            "format": ""
        },
        {
            "name": "entryPointPath",
            "baseName": "entryPointPath",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SparkJobRequestedSource.attributeTypeMap;
    }
    constructor() {
    }
}
